import { render } from "./TicketTransfertDialog.vue?vue&type=template&id=258b4aa8"
import script from "./js/ticketTransfertDialog.js?vue&type=script&lang=js&external"
export * from "./js/ticketTransfertDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__